import { match as uuid } from "../../../src/params/uuid.ts";

export const matchers = { uuid };